import { TableColumProps } from "@/components/molecules/Table";
import { fakeI18n } from "@/i18n";
import { Claim, ClaimSortProperty } from "@/shared/domain/claim";

export const claimTableColumns: TableColumProps<Claim, ClaimSortProperty>[] = [
    {
        sortableKey: "description",
        label: fakeI18n.t("Common.Description"),
        width: 29,
    },
    {
        sortableKey: "reference",
        label: fakeI18n.t("Common.Reference"),
        width: 12,
    },
    {
        sortableKey: "circumstance.name",
        label: fakeI18n.t("Common.Circumstance"),
        width: 24,
    },
    {
        sortableKey: "objectType.name",
        label: fakeI18n.t("Common.Concerns"),
        width: 20,
    },
    {
        sortableKey: "damageEventDate",
        label: fakeI18n.t("Common.Date"),
        width: 12,
    },
    {
        sortableKey: "brokerState.id",
        label: fakeI18n.t("Common.Status"),
        width: 12,
    },
];
